import {AdminPagingModel} from "./AdminPagingModel";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import { PrintJob } from "../../entities/PrintJob";
import { PrintJobService } from "../../services/PrintJobService";

export class PrintJobAdminPagingModel extends AdminPagingModel<PrintJob>{
        static $inject = ['$q','PrintJobService','NotificationService','GridBookmarkService'];
        constructor($q:ng.IQService, pagingService:PrintJobService,notificationService:NotificationService,
                    gridBookmarkService:GridBookmarkService){
            super($q, pagingService,notificationService,gridBookmarkService);
        }
        getCustomActions():string[]{
            return [];
        }
        entityName():string{
            return "printjob";
        }
        displayName():string{
            return "Print Jobs";
        }
        addEditAllowed():boolean{
          return false;
        }
        deleteAllowed():boolean{
          return true;
        }
        transformItem(entity:PrintJob){
        }
        getColumnDefs():ng.IPromise<void>{
            this.nameValuePairs =
                [
                    ['created', 'Created', 200],
                    ['tableName', 'Table Name', 120],
                    ['completed', 'Completed', 90],
                    ['assetName', 'Asset Name', 130],
                    ['locationName', 'Location Name', 130],
                    ['templateName', 'Template Name', 130],
                    ['useWithService', 'Use With Service', 130],
                    ['message', 'Message', 300]                    
                ];
            return this.$q.when();
        }
    }
